<template>
  <div class="container">
    <!-- 菜单导航 -->
    <Menu></Menu>
    <!-- 圈子 -->
    <div class="main-wrapper-content circle">
      <div>
        <el-tabs v-model="activeName" :tab-position="tabPosition" @tab-click="handleClick">
          <el-tab-pane name="tuijian" label="推荐">
          </el-tab-pane>
          <el-tab-pane name="dongtai" label="动态">
          </el-tab-pane>
          <el-tab-pane name="work" label="作业">
          </el-tab-pane>
          <el-tab-pane name="case" label="作品">
          </el-tab-pane>
        </el-tabs>
        <div class="circle-content">
          <div class="circle-flex">
            <div class="circle-center">
              <!---- img 轮播 ---->
              <div style="width:780px;margin:0 auto;height:276px">
                <!-- Using the slider component -->
                <slider ref="slider" :options="options" @slide='slide' @tap='onTap' @init='onInit'>
                  <!-- slideritem wrapped package with the components you need -->
                  <slideritem v-for="(item, index) in someList" :key="index" :style="item.style">
                    <img :src="item.imgUrl">
                  </slideritem>
                  <!-- Customizable loading -->
                  <div slot="loading">loading...</div>
                </slider>
              </div>
              <!---- tabs ---->
              <div class="circle-center_tabs">
                <el-tabs v-model="tabActive" @tab-click="tabClick">
                  <el-tab-pane label="全部" name="first">
                    <Post :listData="listData"></Post>
                    <div class="loading-page">
                      <div class="empty-btn" v-if="this.pageMax == 0 ||this.page >= this.pageMax">没有更多了</div>
                      <div class="empty-btn" @click="showListData()" v-else>点击展开更多</div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
        </div>
        <div class="circle-right">
          <div class="user-main">
            <div class="top"><img src="../assets/user_t.jpg" height="100%" /></div>
            <div class="bottom">
              <div class="userInfo" v-if="userInfo.id>0">
                <img :src="userInfo.avatar_url" />
                <h4>{{ userInfo.nickname }}</h4>
              </div>
              <div class="userInfo" v-else>
                <img src="../assets/user.jpg" />
                <h4>请登录</h4>
              </div>
              <div class="button">
                <li class="btn-box-item" style="margin-right:10px;">
                  <router-link to="/personal">
                    我的发布
                  </router-link>
                </li>
                <li class="btn-box-item" @click="toTYlist">
                  作业提交
                </li>
              </div>
              <div v-if="userInfo.user_type == 2" class="button" style="padding:10px 20px 20px;">
                <li class="btn-box-item" style="margin-right:10px;" @click="openHomework">
                  作品发布
                </li>
                <li class="btn-box-item" @click="openActive"> 发布动态 </li>
              </div>
            </div>
          </div>
          <div>
            <div class="advertising-list"></div>
            <!-- <div>
              <div class="recommend-course-box">
                <div class="title-box">最新活动</div>
                <div class="course-item" v-for="(item,index) in activityData" :key="index">
                  <div class="course-cover">
                    <img :src="item.image" class="course-image" @click="showActivity(item.id)" />
                  </div>
                  <h4>{{ item.title }}</h4>
                  <p>结束时间：{{item.end_time}}</p>
                </div>
                <div class="bottom-box">
                  <router-link :to="{path:'activity'}">更多精选</router-link>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div style="clear:both;"></div>
    </div>
    <!-- 底部链接 -->
    <Footer></Footer>
    <!-- 发布动态弹窗 -->
    <el-dialog :title="title" v-if="open" :visible.sync="open" width="650px" append-to-body class="adddDialog"
      @open="$refs.formSX.clearValidate()" :before-close="reset">
      <el-form ref="formSX" :model="form" label-width="132px" label-position="top">
        <el-form-item label="标题：">
          <el-input v-model="form.title" class="textareaadd"></el-input>
        </el-form-item>
        <el-form-item :label="title == '发布动态' ? '发一发动态，聊一聊心情：' : '聊聊你的看法：'">
          <el-input type="textarea" v-model="form.content" class="textareaadd"></el-input>
        </el-form-item>
        <el-form-item label="上传图集/视频">
          <el-upload action="/api/index/upload" list-type="picture-card" :on-success="picSucess"
            :on-remove="handleRemove" :before-upload="uploadStatus">
            <div slot="tip" class="el-upload__tip">只能上传jpg/png/mp4文件，且不超过40MB</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">提 交</el-button>
        <el-button type="info" @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img :src="dialogImageUrl" alt="">
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleVideo" v-if="dialogVisibleVideo">
      <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions">
      </video-player>
    </el-dialog>
  </div>
</template>
<script>
  import Post from '@/components/view/Main/Post'
  import Menu from '@/components/view/Menu'
  import Footer from '@/components/view/Footer'
  import {
    slider,
    slideritem
  } from 'vue-concise-slider'
  export default {
    name: 'circlea',
    data() {
      return {
        userInfo: [],
        tabPosition: 'left',
        activeName: 'tuijian',
        tabActive: 'first',
        someList: [{
          html: 'slider1',
          imgUrl: require('@/assets/circle/img01.png')
        }],
        options: {
          currentPage: 0,
          loop: true
        },
        open: false,
        form: {
          title: "",
          content: ""
        },
        rules: [],
        dialogImageUrl: "",
        ImageUrls: [],
        dialogVisible: false,
        videoFirstimgsrc: "",
        VideoeUrls: [],
        dialogVisibleVideo: false,
        title: "",
        VideoeUrlsfiles: [],
        plTotal: null,
        activityData: {},
        listData: [],
        page: 1,
        pageMax: 0
      }
    },
    created() {
      this.getUser()
      this.showListData(100)
      this.getCourseData()
    },
    methods: {
      // 用户信息
      getUser() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/user/userInfo', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          }
        }).then(res => {
          this.userInfo = res.data.data
        }).catch(err => {
          console.log(err)
        })
      },
      // tab切换
      handleClick(tab, event) {
        this.listData = []
        this.page = 1
        let index = tab.index
        if (index == 0) {
          this.showListData(100)
        } else if (index == 2) {
          this.showListData(3)
        } else if (index == 3) {
          this.showListData(4)
        } else {
          this.showListData(index)
        }
      },

      getCourseData() {
        this.$axios({
          method: 'post',
          url: '/api/activity/listData',
          data: {
            page: 1,
            limit: 10
          },
          headers: {
            token: this.$cookieStore.getCookie('token')
          }
        }).then(res => {
          this.activityData = res.data.data.data
        }).catch(err => {

        })
      },

      // type:100 推荐
      showListData(type) {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/post/listData', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            type: type,
            page: this.page
          }
        }).then(res => {
          for (var i = 0; i < res.data.data.data.length; i++) {
            this.listData.push(res.data.data.data[i])
          }
          this.pageMax = res.data.data.last_page
          this.page = this.page++
        }).catch(err => {

        })
      },
      showActivity(id) {
        this.$router.push({
          path: "/activitydetail",
          query: {
            id: id
          }
        })
      },
      toTYlist() {
        this.$router.push({
          path: "/Publishlist",
          query: {}
        })
      },
      // 移除上传文件
      handleRemove(file, list) {
        var imgList = this.ImageUrls;
        var videoList = this.VideoeUrls;
        if (imgList.length > 0) {
          for (var i = 0; i < imgList.length; i++) {
            if (imgList[i] == file.response.data.data.thumb) {
              imgList.splice(i, 1)
            }
          }
          this.ImageUrls = imgList;
        }
        if (videoList.length > 0) {
          this.VideoeUrls = []
          this.this.VideoeUrlsfiles = []
        }
      },
      uploadStatus(file) {
        if (this.ImageUrls.length > 0) {
          if (file.type == 'video/mp4') {
            return false;
          }
        }
        if (this.VideoeUrls.length > 0) {
          return false;
        }
      },
      picSucess(res, file) {
        let str = file.name.split(".")[1]
        if (str == "mp4" || str == "mov" || str == "m4v" || str == "3gp" || str == "avi" || str == "dat" || str ==
          "mkv" || str == "flv" || str == "vob" || str == "mpg" || str == "mpeg" || str == "mpe") {
          this.VideoeUrls.push(res.data.data.thumb)
          this.findvideocover(res.data.data.src, file);
        } else {
          this.ImageUrls.push(res.data.data.thumb);
        }
      },

      videoSucess(res, file) {
        this.VideoeUrls.push(res.data.data.src);
        this.findvideocover(res.data.data.src, file);
      },

      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.response.data.data.src
        this.dialogVisible = true;
      },

      handlePictureCardPreviewVideo(file) {
        this.playerOptions.sources[0].src = file.response.data.data.src
        this.dialogVisibleVideo = true;
      },

      //截取视频第一帧作为播放前默认图片
      findvideocover(url, file) {
        console.log(url)
        console.log(file)
        // const  video = document.getElementById("myvideo"); // 获取视频对象
        const video = document.createElement("video") // 也可以自己创建video
        video.src = url // url地址 url跟 视频流是一样的
        // var canvas = document.getElementById('mycanvas') // 获取 canvas 对象
        var canvas = document.createElement('canvas') // 获取 canvas 对象
        const ctx = canvas.getContext('2d'); // 绘制2d
        video.crossOrigin = 'anonymous' // 解决跨域问题，也就是提示污染资源无法转换视频
        video.currentTime = 1 // 第一帧
        video.oncanplay = () => {
          canvas.width = video.clientWidth ? video.clientWidth : 320; // 获取视频宽度
          canvas.height = video.clientHeight ? video.clientHeight : 320; //获取视频高度
          // 利用canvas对象方法绘图
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
          // 转换成base64形式
          this.videoFirstimgsrc = canvas.toDataURL("image/png"); // 截取后的视频封面
          file.url = this.videoFirstimgsrc;
          // base64转成bolb文件
          const fileBolb = this.base64toFile(this.videoFirstimgsrc, this.getFileName(file))
          // 把首图上传生成云上地址
          this.getFirstPngUrl(fileBolb);
          video.remove();
          canvas.remove();
        }
      },

      base64toFile(baseUrl, filename = 'file') {
        let arr = baseUrl.split(',');
        let type = arr[0].match(/:(.*?);/)[1]; // 解锁图片类型
        let bytes = atob(arr[1]); // 解码base64
        let n = bytes.length
        let bufferArray = new Uint8Array(n);
        while (n--) {
          bufferArray[n] = bytes.charCodeAt(n);
        }
        return new File([bufferArray], filename, {
          type
        });
      },

      getFirstPngUrl(file) {
        const fd = new FormData();
        fd.append('file', file);
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/index/upload', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token'),
            'Content-Type': 'multipart/form-data'
          },
          data: fd
        }).then(res => {
          console.log(res)
          this.VideoeUrlsfiles[0] = res.data.data.data.src
        }).catch(err => {
          console.log(err)
        })
      },

      getFileName(file) {
        const type = file.raw.type.split("/")[1];
        let name = '';
        if (type) {
          name = file.raw.name.substring(0, file.raw.name.indexOf(`.${type}`));
        }
        return `${name}.png`;
      },

      submitForm() {
        let form = {
          "homework_id": "",
          "title": this.form.title,
          "content": this.form.content,
          "images": this.ImageUrls,
          "media": this.VideoeUrls,
          "media_cover": this.VideoeUrlsfiles,
          "type": this.title == "发布动态" ? "1" : "4"
        }
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/post/submit', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: form
        }).then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            });
            this.open = false
            this.reset()
          } else {
            this.$message.error(res.data.msg);
            this.open = false
            this.reset()
          }
        }).catch(err => {
          console.log(err)
        })
      },

      cancel() {
        this.open = false
        this.reset()
      },

      openActive() {
        this.title = "发布动态"
        this.open = true
      },
      openHomework() {
        this.title = "发布作品"
        this.open = true
      },
      reset() {
        this.form = {
          title: "",
          content: ""
        }
        this.dialogImageUrl = ""
        this.ImageUrls = null
        this.VideoeUrls = null
        this.videoFirstimgsrc = ""
        this.open = false
      },
    },
    components: {
      Menu,
      Footer,
      slider,
      slideritem,
      Post
    }
  }
</script>
<style scoped lang="scss">
  .user-main {
    width: 270px;
    overflow: hidden;
    background: #f5f8f8;
    border-radius: 6px;

    .top {
      height: 100px;
    }
  }

  .user-main .bottom {
    width: 100%;
    text-align: center;

    a {
      color: rgba(0, 0, 0, .65);
    }

    .button {
      display: flex;
      padding: 30px 20px 10px;
    }

    img {
      position: relative;
      width: 75px;
      height: 75px;
      top: -40px;
      border-radius: 80px;
      margin-bottom: -30px;
    }

    .btn-box-item {
      width: 113px;
      line-height: 35px;
      margin-top: 0;
      background: #FABE00;
      border-radius: 8px;
    }
  }

  .empty-btn,
  .loading-btn {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #fff8f1;
    border-radius: 6px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 400;
    color: #f80;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .circle-content {
    width: 780px;
    float: left;
  }

  /deep/ .el-tabs--left,
  .el-tabs--right {
    overflow: visible !important;
  }

  /deep/ .el-tabs--left .el-tabs__header.is-left {
    position: fixed;
    top: 100px;
    z-index: 999;
  }

  /deep/ .el-tabs__content {

    overflow: visible !important;
  }

  /deep/ .circle-center_tabs .el-tabs__header {
    padding: 14px 10px !important;
  }

  .fenxiang {
    position: absolute;
    right: 190px;
    padding-top: 8px;
    z-index: 1100000;

  }

  .video_box {
    width: 100%;

    .video-player {
      width: 400px;
      height: 250px;
      display: inline-block;
    }

    /deep/ .vjs-custom-skin>.video-js .vjs-big-play-button {
      background-color: rgba(0, 0, 0, 0.45);
      font-size: 2.5em;
      width: 4rem;
      /* border-radius: 50%; */
      height: -7em !important;
      /* line-height: 2em !important; */
      margin-top: -1em !important;
    }

    /deep/.vjs-custom-skin>.video-js .vjs-big-play-button {
      top: 50%;
      left: 50%;
      margin-left: -1.5em;
      margin-top: -1em;
    }
  }

  //  弹出层
  .adddDialog {
    /deep/ .el-dialog {
      padding: 15px;
      border-radius: 15px;
    }

    /deep/ .el-button--primary {
      background: linear-gradient(159deg, #1cdc94, #FABE00) !important;
      box-shadow: 0 2px 8px 0 rgba(12, 182, 91, 0.4) !important;
      color: #fff !important;
    }

    /deep/ .el-textarea__inner {
      width: 100%;
      height: 101px;
      background: #f7f7f7;
      border-radius: 10px;
      border: 1px solid #dcdcdc;
      padding: 14px 16px 16px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
      font-weight: 500;
      color: #18252c;
      line-height: 20px;
    }

    /deep/ .el-input__inner {
      width: 50%;
      background: #f7f7f7;
      border-radius: 10px;
      border: 1px solid #dcdcdc;
      padding: 14px 16px 16px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
      font-weight: 500;
      color: #18252c;
      line-height: 20px;
    }

    /deep/ .el-upload--picture-card {
      background: #f5f8f8;
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABGCAYAAAB12zK5AAAC2UlEQVR4Xu2cv2sUQRzF5+2dRgUbwcLiMBaR5GbONCLaacC/QEysRI1oTGtpIWhp7Q+iRAvBSPInqGihFtqEmyELB6JNLMRKISSb7JMNUZIzbpiLd7Mh3+sOZvb7vp99b2ePGQ5KPmsIoAg8Zmdn9ywtLbFSqcyF1hMUiHNuIE3TO0qp/hUQ00qp67Va7XUoMMGA1Ov1IQDPSK7RAIAAhrTWkyGgBAESx/HexcXFzyT3rdc0gO9KqW5jzM9OQwkCxFp7iuSrvGbL5fLJvr6+N9sCiHNuJE3T+3nNArhqjBnbFkCstaMk7+Y1G0XRNa31AwGyQkCANFlBgAgQeYb88YA8VJviIEAESP7bgzhEHCIO8XrDlshIZCQyEhkvAhIZiYyXYWSVkchIZCQyXgQkMhIZL8NsiVVmZmbmcJqm50j2k9zl1aHnYAAHSeoNNqocyS+el/YaDiA7bTAdRdFEtVptZJOXtzKdc5eyjaN2g/BS29nBcwBGjTFPEMfxkSRJPiqldnRWQ7GqAVgolUpHUa/Xsz3WkWLJC6MGwL0MyDul1IkwEopVFcBbWGunSJ4plrRgaiYzIJdJPgwmoUCFoygaRnakyTn3guRAgbR1XAqAl1rr08vLrrV2J4CbJC+SPNBxNQELAvgKYJzkLWPMwl9HqhqNxv75+fndbdZ4nuTtDWrcAPC0nTq6urrmenp6vq2uEeqMmZwgWn0XtsRvmXZas/naAqSJiAARIPkBFIeIQ8QhXouUREYiI5GRyHgRkMhIZLwMI6uMREYiI5HxIiCRkch4GUZWGYmMREYi40WgabBzbjBN0+d514ii6KzWemozdVqZG2SjKo7jQ0mSfMoTXCqVuqvValuPVK1XPwiQTIi19jHJC/+AMl6r1YZbucObnRMMSPYfIkmSPFJKDa5uAsBEuVy+0tvb+2OzzbUyPxiQ32Kdc8eUUsez7yTfG2M+tNLI/5rzCxKRSWrxysTGAAAAAElFTkSuQmCC);
      background-size: 34px 35px;
      background-repeat: no-repeat;
      background-position: 50%;
      cursor: pointer;
      width: 120px;
      height: 120px;
    }

    /deep/ .el-upload-list--picture-card .el-upload-list__item {
      width: 120px;
      height: 120px;
    }
  }

  .share_box:hover>.share__icon {
    background: url("data:image/png;base64,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") 100% 100% no-repeat;
    background-size: 100%;
  }
</style>
<style scoped>
  .less-than-four-content {
    width: 100%;
  }

  .circle {
    padding-top: 30px;
    margin: 0px;
    width: 1190px;
    padding-left: 10px;
    margin: 0 auto;
  }

  .circle-center {
    width: 780px;
    margin-left: 125px;
  }

  .slider-item img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }

  .list-img-box {
    margin-top: 31px;
    margin-bottom: 20px;
  }

  .less-than-four-content {
    flex: 1;
    margin-left: 12px;
    position: relative;
    cursor: pointer;
  }

  .page-detail-card-star {
    float: left;
    width: 80px;
    height: 24px;
    margin-right: 4px;
  }

  .card-work-link {
    padding: 0 32px 0 26px;
    display: table-caption;
    height: 24px;
    line-height: 24px;
    background: #e6f7ee;
    border-radius: 12px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 400;
    color: #FABE00;
    cursor: pointer;
    position: relative;
  }

  .work-link-icon {
    position: absolute;
    display: inline-block;
    transform: translateY(-50%);
    top: 50%;
    left: 8px;
    width: 14px;
    height: 14px;
    background: url('~@/assets/circle/img12.png') 100% 100% no-repeat;
  }

  .work-link-to-icon {
    position: absolute;
    display: inline-block;
    transform: translateY(-50%);
    top: 50%;
    right: 8px;
    width: 12px;
    height: 12px;
    background: url('~@/assets/circle/img13.png') 100% 100% no-repeat;
  }

  .card-work-link-msg {
    max-width: 637px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .list-flex {
    position: relative;
    display: flex;
  }

  .play-btn {
    position: absolute;
    top: 68px;
    left: 15%;
    transform: translateX(-50%);
    width: 60px;
    text-align: center;
  }

  .less-than-four-img {
    position: relative;
    width: 260px;
    height: 195px;
    overflow: hidden;
    border-radius: 5px;
    cursor: pointer;
  }

  .less-than-four-img img,
  .play-btn img {
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
  }

  /**circle-right */
  .circle-right {
    height: inherit;
    margin-left: 15px;
    float: right;
  }

  .advertising-list {
    width: 247px;
    font-size: 0;
  }

  .recommend-course-box {
    display: flex;
    width: 270px;
    background: #fff;
    box-shadow: 0 0 6px 0 rgb(0 0 0 / 5%);
    border-radius: 8px;
    align-items: center;
    flex-direction: column;
    padding-bottom: 20px;
    margin-top: 24px;
  }

  .title-box {
    width: 100%;
    height: 58px;
    background-image: url('~@/assets/circle/img22.png');
    background-size: 100%;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333;
    line-height: 22px;
    padding-left: 16px;
    box-sizing: border-box;
  }

  .course-item {
    box-sizing: border-box;
    width: 235px;
    margin-bottom: 24px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    position: relative;
    cursor: pointer;
    text-align: center;
  }

  .course-cover {
    position: relative;
    font-size: 0;
  }

  .course-cover>.unstart {
    padding: 3px 8px 3px 0;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #fff;
    background: rgba(14, 14, 14, .62);
    border-radius: 15px;
    display: inline-block;
  }

  .course-state {
    position: absolute;
    top: 8px;
    left: 8px;
  }

  .unstart-tip {
    margin-right: 6px;
    background: #44d7b6;
    border-radius: 20px;
    color: #18252c;
    padding: 4px 8px;
  }

  .course-image {
    width: 100%;
    height: 142px;
    border-radius: 8px 8px 8px 8px;
    overflow: hidden;
  }

  .course-state-name {
    position: absolute !important;
    bottom: 8px !important;
    left: 10px !important;
  }

  .courseName {
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #fff;
    line-height: 14px;
    font-size: 14px;
    text-shadow: 0 1px 2px rgb(0 0 0 / 30%);
  }

  /* .el-tab-pane{display: flex;} */
  .btn-box {
    width: 247px;
    height: 216px;
    background: #f5f8f8;
    border-radius: 8px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .user-box {
    position: relative;
    z-index: 99;
  }

  .btn-box-item {
    cursor: pointer;
    font-family: PingFangSC-Regular, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-size: 12px;
    text-align: center;
    width: 45%;
    margin-top: 10px;
  }

  .btn-box-item img {
    width: 60px;
    height: 60px;
  }

  .btn-box-item p {
    line-height: 17px;
    margin-top: 5px;
  }

  .course-item>h4 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 16px 0 10px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #18252c;
  }

  .course-teacher {
    display: flex;
    align-items: center;
  }

  .course-teacher img {
    width: 20px;
    height: 20px;
    margin: 0 4px 0 0;
    border-radius: 10px;
  }

  .course-teacher-nickname {
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #747c80;
    line-height: 20px;
  }

  .total-student {
    margin-left: auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .bottom-box {
    height: 32px;
    background: #fafafa;
    border-radius: 4px;
    width: 215px;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

  }

  .bottom-box a {
    color: #747c80;
  }

  .circle-flex {
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/Circle.vue